<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title jpn="Coin利用規約" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">株式会社ゼロプレイス（以下、「当社」といいます。）が提供する
              <a href="https://gtchaxonline.com/" target="_blank" >https://gtchaxonline.com/</a>
              （以下、「本件サービス」といいます。）において「Coin」（以下に定義します）を利用するにあたり、その利用に関する条件を定めるもの（以下、「Coin利用規約」といいます。）です。</span>
            <span class="text">十分にCoin利用規約の内容をご確認いただいた上で、Coinのご購入をご検討ください。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第1条 - 用語の定義</span>
            <span class="text">本件規約における以下の各号の用語の意味は、当該各号に定めるとおりとします。</span>
            <span class="text">(1)「サービス利用契約」とは、本件サービスの利用に関する契約をいいます。</span>
            <span class="text">(2)「サービス利用者」とは、当社とサービス利用契約を締結した者をいいます。</span>
            <span class="text">(3)「アカウント情報」とは、サービス利用者が本件サービスに登録したサービス利用者に関する情報をいいます。</span>
            <span class="text">(4)「Coin」とは、当社でのみ利用可能な通貨をいいます。</span>
            <span class="text">(5)「利用残高」とは、サービス利用者が保有し、利用することのできるCoinの残高となります。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第2条 - Coin</span>
            <span class="text">(1)サービス利用者は、当社所定の方法により、当社が本件サービス内で提示している金額で本件サービス内で使用可能なCoinを購入することができます。なお、当社は、サービス利用者に対して、Coinの購入について購入単位、決済方法、利用期間その他の購入条件を設けることがあり、設定した購入条件及び支払可能金額等は、本件サービス又は当社の運営するサービス内に掲載します。</span>
            <span class="text">(2)サービス利用者が当社所定の方法によりCoinの購入の意思表示を行った時点で、当該Coinの購入に関するサービス利用者と当社の間の契約は成立し、購入にかかる総額が確定するものとします。</span>
            <span class="text">(3)Coinを購入するサービス利用者が未成年者である場合、当該サービス利用者はCoinの購入についてあらかじめ親権者の同意を得なければなりません。</span>
            <span class="text">(4)当社は未成年者がCoinを購入した場合、親権者が当該Coinの購入に同意したものとみなします。</span>
            <span class="text">(5)本件サービス内に表示されているサービス利用者の利用残高は、アカウント情報に紐づいて本件サービス及び当社の運営する他のサービスの提供にかかる電気通信設備に記録されます。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第3条 - Coinの利用</span>
            <span class="text">(1)Coinは、当社の商品購入のために使用することができます。</span>
            <span class="text">(2)サービス利用者は、Coinの残高の範囲内で、当社が提供する商品を取得することができます。</span>
            <span class="text">(3)サービス利用者が当社から商品を購入する際にCoinを使用した場合、Coinの残高から商品の代金を差し引くことにより、当該代金額の支払があったものとみなされます。</span>
            <span class="text">特段の定めがない場合、本件サービス内で当社からサービス利用者に対して無償で付与したCoinから優先的に消費されます。</span>
            <span class="text">(4)サービス利用者は本件サービス内でCoinの残高を確認することができます。なお、サービス利用者はCoinの増減を自身の責任で管理し、確認するものとします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第4条 - Coinの取り扱い</span>
            <span class="text">(1)当社は、本サービスにおいて利用者がCoinを購入した場合、当社がキャンペーンを実施する場合その他の場合に、当社の定める方法により、利用者にCoinを付与します。Coinの購入単位、価格、有効期間、その他のCoinの付与条件は、当社が定め、本サービス上に表示します。</span>
            <span class="text">(2)Coinの有効期間は、Coinが付与された日から6か月とします。</span>
            <span class="text">(3)当社は、利用者が取得したCoinについて、法令上必要な場合を除き、一切払い戻しを行いません。法令に基づきCoinを払い戻す場合の払戻方法および条件は、別途当社が定める方法で掲示するものとします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第5条 - 換金行為の禁止等</span>
            <span class="text">本サービス内で取得した一切のコンテンツについては、直接、第三者による仲介又はインターネットオークション等その手段を問わず、売買その他、金銭その他現実世界における対価を授受する形でのあらゆる譲渡、譲受、貸与、借用等する行為（いわゆるRMT【リアルマネートレード】を含みますが、これに限られません。また、本サービス内におけるユーザーの行為に対して金銭その他、現実世界における対価を授受することも含みます。）を禁止いたします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第6条 - Coinの譲渡等</span>
            <span class="text">サービス利用者は、Coin及び商品を第三者に譲渡、貸与、贈与その他の移転や、質入れその他の担保権の設定をすることはできません。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第7条 -Coinの購入及び利用の停止等</span>
            <span class="text">サービス利用者が以下に該当する場合、当社はサービス利用者に対して、当社が適当と判断する措置（Coinの購入や利用の停止を含むがこれに限りません）を実施できるものとします。</span>
            <span class="text">(1)不正な方法によりCoinや商品を取得、利用した場合</span>
            <span class="text">(2)サービス利用者が本件規約に違反した場合</span>
            <span class="text">(3)その他、当社がサービス利用者の本件サービスの利用を不適切であると判断した場合</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">2025年2月28日 制定</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
